<script setup lang="ts">
  import { ref } from 'vue';
	import { useFeedbackFormStore } from '~/stores/FeedbackFormStore';
  import { required, minLength } from '@vuelidate/validators';
  import { useVuelidate } from '@vuelidate/core';
  import { useSettingsStore } from '~/stores/SettingsStore';

  const feedback = useFeedbackFormStore();
  const { $toast } = useNuxtApp();
  const loading = ref(false)
  const settingsStore = useSettingsStore();

  const clientInfo = ref({
    clientName: '',
    clientPhone: '',
    clientEmail: '',
    clientWebsite: '',
    clientCity: '',
    clientExperience: '',
    clientComment: '',
    is_read: false,
    is_agree: false,
  });

  const rules = computed(() => {
    return {
      clientName: { required, minLength: minLength(2) },
      clientPhone: { required, minLength: minLength(10) },
    };
  });

  const v$ = useVuelidate(rules, clientInfo);

  const submit = async () => {
    v$.value.$validate();
    if (!v$.value.$error) {
      loading.value = true;
      await feedback.send(clientInfo);
      loading.value = false;
      clientInfo.value.clientName = '';
      clientInfo.value.clientPhone = '';
      clientInfo.value.clientEmail = '';
      clientInfo.value.clientWebsite = '';
      clientInfo.value.clientCity = '';
      clientInfo.value.clientExperience = '';
      clientInfo.value.clientComment = '';
      clientInfo.value.is_read = false;
      clientInfo.value.is_agree = false;
      v$.value.$reset();
      if (window && window.ym) {
        window.ym(99787939,'reachGoal','form_callback_new');
      }
      $toast.success('Форма успешно отправлена')
    } else {
      $toast.error('Заполните форму корректно')
    }
  };
</script>

<template>
  <div class="feedback-form">
    <div class="feedback-form__title title">Форма заявки для начала работы по безналичной оплате</div>
    <div class="feedback-form__content">
      <div class="feedback-form__form">
        <div class="form-block__box">
          <div class="form-block__field">
            <input 
              type="text" 
              placeholder="ФИО" 
              class="form-control form-control-small"
              v-model="clientInfo.clientName"
              :class="{'form-control-error': feedback.errors.includes('data.clientName') || v$.clientName.$error}"
            >
          </div>
          <div class="form-block__field">
            <vue-tel-input
              v-model="clientInfo.clientPhone"
              class="form-control form-control-small"
              placeholder="Номер телефона"
              :class="{'form-control-error': feedback.errors.includes('data.clientPhone') || v$.clientPhone.$error}"
            ></vue-tel-input>
          </div>
          <div class="form-block__field">
            <input 
              type="text" 
              placeholder="Электронная почта" 
              class="form-control form-control-small"
              v-model="clientInfo.clientEmail"
            >
          </div>
          <div class="form-block__field">
            <input 
              type="text" 
              placeholder="Сайт вашей компании" 
              class="form-control form-control-small"
              v-model="clientInfo.clientWebsite"
            >
          </div>
          <div class="form-block__field">
            <input 
              type="text" 
              placeholder="Город" 
              class="form-control form-control-small"
              v-model="clientInfo.clientCity"
            >
          </div>
          <div class="form-block__field">
            <textarea 
              name="" 
              id="" 
              cols="30" 
              rows="10" 
              placeholder="Опыт в прокате, если есть" 
              class="form-control form-textarea"
              v-model="clientInfo.clientExperience"
            ></textarea>
          </div>
          <div class="form-block__field">
            <textarea 
              name="" 
              id="" 
              cols="30" 
              rows="10" 
              placeholder="Комментарий" 
              class="form-control form-textarea"
              v-model="clientInfo.clientComment"
            ></textarea>
          </div>
        </div>
        <div class="form-block__checkbox">
          <div class="custom-checkbox">
            <input type="checkbox" name="conditions" id="conditions" v-model="clientInfo.is_read">
            <label for="conditions"><span>Я ознакомился c условиями по франшизе</span></label>
          </div>
        </div>
        <div class="form-block__checkbox">
          <div class="custom-checkbox">
            <input type="checkbox" name="personal-data" id="personal-data" v-model="clientInfo.is_agree">
            <label for="personal-data"><span>Я согласен на обработку персональных данных</span></label>
          </div>
        </div>
        <div class="feedback-form__row">
          <!-- <div class="feedback-form__captcha">
            <img src="/img/captcha.png" alt="">
          </div> -->
          <div class="feedback-form__button">
            <button class="button button-accent" @click="submit" v-if="!loading">Отправить</button>
            <button class="button button-accent" v-else>Отправляем...</button>
          </div>
        </div>
      </div>
      <div class="feedback-form__details">
        <div class="order-form__phone">
          <a href="tel:+74957779930" class="order-form__phone-link">{{ settingsStore.phone }}</a>
        </div>
        <div class="order-form__socials">
          <div class="order-form__text">Задать вопрос в мессенджерах</div>
          <div class="order-form__socials-content">
            <a v-if="settingsStore && settingsStore.links && settingsStore.links.viber_url" :href="`${settingsStore.links.viber_url}`" target="_blank" class="order-form__socials-item order-form__socials-item--viber"></a>
            <a href="https://t.me/mycarrental_support_bot" target="_blank" class="order-form__socials-item order-form__socials-item--telegram"></a>
            <a href="https://api.whatsapp.com/send/?phone=79952260541&text&type=phone_number&app_absent=0" target="_blank" class="order-form__socials-item order-form__socials-item--whatsapp"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>